import { css } from 'styled-components';

import { theme } from '../../../styles';
import { spacing } from '../../../styles/spacing';

const topBarInnerHeight = 40;
const topBarPaddingVertical = { default: 30, mobile: 20 };

export const topBarHeight = {
  default: topBarInnerHeight + 2 * topBarPaddingVertical.default,
  mobile: topBarInnerHeight + 2 * topBarPaddingVertical.mobile,
};

export const topBarStyle = css`
  background-color: ${theme.colors.foraBlue};
  height: ${topBarInnerHeight}px;

  // Desktop
  padding: ${topBarPaddingVertical.default}px 40px;

  // Tablet
  @media (max-width: ${spacing.breakpoint.lg - 1}px) {
    padding: ${topBarPaddingVertical.default}px 20px;
  }
  // Mobile
  @media (max-width: ${spacing.breakpoint.md - 1}px) {
    padding: ${topBarPaddingVertical.mobile}px 20px;
  }
`;

export const bannerStyle = css`
  display: flex;
  align-items: center;
  max-width: 100%;
  min-height: 6.25rem;
  margin: 0;
  padding: 0 40px; // Must be set to pixels to have a good resizing of the navbar on zoomed browsers
  background-color: ${theme.colors.foraBlue};
  top: 0rem;
`;

export const staticTextSmallStyle = css`
  ${theme.typography.textSmall};
  font-size: 14px;
  line-height: 1.43;
  margin: 0;
`;
